import EventModel from "@/models/event/eventModel";
import { apiClient } from "./apiService";
import { AxiosResponse } from "axios";
import EventUpsertModel from "@/models/event/eventUpsertModel";

export default {
  async getAllEventsAsync(): Promise<Array<EventModel>> {
    const response = await apiClient.get("event");
    return response.data.map((x: AxiosResponse) => new EventModel(x));
  },
  async getAllEventsByYear(
    year: number,
    calendarId: string
  ): Promise<Array<EventModel>> {
    const response = await apiClient.get(`event/year/${year}/${calendarId}`);
    return response.data.map((x: AxiosResponse) => new EventModel(x));
  },
  async getEventAsync(eventId: string): Promise<EventModel> {
    const response = await apiClient.get(`event/${eventId}`);
    return new EventModel(response.data);
  },
  async createEvent(model: EventUpsertModel): Promise<EventModel> {
    const response = await apiClient.post(`event`, model);
    return new EventModel(response.data);
  },
  async updateEvent(
    eventId: string,
    model: EventUpsertModel
  ): Promise<EventModel> {
    const response = await apiClient.put(`event/${eventId}`, model);
    return new EventModel(response.data);
  },
  async deleteEvent(eventId: string): Promise<void> {
    await apiClient.delete(`event/${eventId}`);
  }
};
